module.exports = __webpack_public_path__ + "static/media/ashblack.ec8723ba.jpeg";